import { createContext } from 'react';

import type { CountryConfig } from './types';

type CountryConfigContextInterface = {
  config: CountryConfig;
};

export const CountryConfigContext = createContext<CountryConfigContextInterface>({ config: [] });
